import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";

import { NBAstatsPlayerRow, NBAplayerPosition } from '../../utils/NBA/StatsHelper';
import PlayerStats from '../../components/NBA/PlayerStats';
import { getNBASeasonsStat } from "../../services/contestService";


const SeasonStats = (props) => {

    const [selectedPlayerPositionTab, setSelectedPlayerPositionTab] = useState("C");

    const [totalScore, setTotalScore] = useState(0);
    const [playersStatus, setPlayersStatus] = useState([]);
    const [playerDetailModal, setPlayerDetailModal] = useState(false);
    const [playerData, setPlayerData] = useState([]);
    const [weekAndPlayers, setWeekAndPlayers] = useState([]);
    const contestId = props.contestId
    const isUserGame = props.isUserGame
    const [showLoader, setLoader] = useState(false);




    useEffect(() => {
        const getPlayerStats = async (playerPosition) => {
            setLoader(true);
            const requestParam = {
                contestId: contestId,
                isUserGame: isUserGame,
                playerPosition: playerPosition
            };
            
            try {
                
                const seasonStatData = await getNBASeasonsStat(requestParam);
                if (seasonStatData?.success && seasonStatData?.errorCode === 200 && seasonStatData?.data?.playersStatus?.length > 0) {
                    setPlayersStatus(seasonStatData.data.playersStatus);
                    setLoader(false);
                } else {
                    setPlayersStatus([]); //  Handle case where no playersStatus is found.
                    setLoader(false);
                }
            } catch (error) {
                console.error("Error fetching player stats:", error);
                setPlayersStatus([]); //  Clear or reset data in case of an error.
            }
        };
    
        getPlayerStats(selectedPlayerPositionTab);
    }, [selectedPlayerPositionTab, contestId, isUserGame]);



    useEffect(() => {
        // splitting players by weeks
        splitingPlayersByWeek(playersStatus)

    }, [playersStatus])


    const splitingPlayersByWeek = (playersStatus) => {
        // splitting players by weeks
        let scores = 0;
        let wkNumbers = [];
        if (playersStatus && playersStatus.length > 0) {
            playersStatus.forEach((row) => {

                if (wkNumbers.indexOf(row.lineup_week))
                    wkNumbers.push(row.lineup_week)
                else
                    wkNumbers.push('row.lineup_week')

                weekAndPlayers[row.nfl_week] = row;
                if(row.totalScore!=null)
                scores += parseFloat(row.totalScore)
                console.log("scoreeee",row.totalScore)
            });
            setTotalScore(scores)
            setWeekAndPlayers(weekAndPlayers)
        }
    }


 



    const playerPos = NBAplayerPosition(0); // commented for proto

    const updateSelectedPosition = (position) => {
        setSelectedPlayerPositionTab(position)
    }

    const handlePlayerModalClose = () => {
        setPlayerDetailModal(false);
    }

    const handlePlayerModalShow = (data) => {
        setPlayerDetailModal(true);
        setPlayerData(data)
    }

    const playerInfo = (playersStatus, position) => {

        const distinctWeeks = [...new Set(playersStatus.map(item => item.lineup_week))];
        let playerRow = [];
        for (let k = 0; k < distinctWeeks.length; k++) {

            playerRow.push(
                <div className="week-list" key={'playPos' + k}>
                    <h5 key={'h5playPos' + (k)}>Week {distinctWeeks[k]}</h5>
                    {
                        playersStatus.map((player) => {
                            return (
                                player.lineup_week === distinctWeeks[k] ? <div className="player-standings">
                                    {NBAstatsPlayerRow(player, position, handlePlayerModalShow)}
                                </div> : ""
                            )
                        })
                    }
                </div>
            );
        }
        return (playerRow)
    }
    // step 2
    const displayPositionTabs = (playerPos) => {

        const tabLists = playerPos.map((position, indx) => {
            return <Tab eventKey={position.code} title={position.title} key={'TabeventKey' + indx}>
                <div className="seasonstats-data" key={'pos' + indx}>
                    <div className="stats-title">
                        <h4>{position.h4}</h4>
                        <p>TOTAL SCORE: <span>{parseFloat(totalScore) ? parseFloat(totalScore).toFixed(2) : '0.00'}</span></p>
                    </div>
                    {showLoader ? (
                 <div className="playercard" style={{ textAlign: "center" }}>
                     <div className="loader-wrap">
                     <div className="loader"></div>
                    </div>
                 </div>
                 ):(
                    playersStatus && playersStatus.length > 0 ? playerInfo(playersStatus, position) : <span style={{ color: "red" }}>No records to display.</span>)}
                    {(playerDetailModal) && playerData && position.title === playerData.position && <PlayerStats showplayermodal={playerDetailModal} handlePlayerModalClose={handlePlayerModalClose} playerData={playerData} />}
                </div>
            </Tab>
        });
        return tabLists;
    };

    // step 1

    return (
        <Tabs
            defaultActiveKey="quarterback"
            transition={false}
            id="stats-tab"
            className="seasonstats-tab"
            activeKey={selectedPlayerPositionTab}
            onSelect={(k) => updateSelectedPosition(k)}
        >
            {playerPos ? displayPositionTabs(playerPos) : ""}
        </Tabs>
    );
}

export default SeasonStats;
